export const FREE_TIER_CTA = 'Keep current plan';

export const DEFAULT_PAYMENT_ELEMENT_OPTIONS = {
  layout: {
    type: 'tabs',
  },
  paymentMethodOrder: ['apple_pay', 'google_pay', 'card'], // Show Apple Pay and Google Pay first, then card
  wallets: {
    applePay: 'auto',
    googlePay: 'auto',
    link: 'never',
  },
} as const;
